<div class="card" *ngIf="feeder">
  <div class="row">
    <ng-container *ngIf="section == ''">
      <div class="col-6 pr-0">
        <div class="card bg-primary w-100 h-100 p-3 border-card" style="color: white">
          <h3>{{ "comparation-weight-sensor.hopper" | translate }}</h3>
          <h4 class="font-weight-light">
            {{ "comparation-weight-sensor.food-distributed" | translate }}:
            <b class="font-weight-bold" *ngIf="feeder.feeding_details"
              >{{feeder.feeding_details.feeder_ration ? feeder.feeding_details.feeder_ration : '0'
              }} kg.</b
            >
            <!-- {{feeder.weight_sensor.current_value}} -->
          </h4>
          <div class="h-100 d-flex justify-content-end align-items-end">
            <button
              class="btn btn-info"
              (click)="getDataRequest()"
              style="padding: 5px 20px 5px 20px"
            >
              {{ "comparation-weight-sensor.request-current-weight" | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="d-flex justify-content-around aling-items-center p-3 position-relative">
          <button
            class="btn btn-sm position-power"
            [class]="feeder.weight_sensor.power ? 'btn-success' : 'btn-danger'"
            (click)="turnOnOff(feeder.weight_sensor.power)"
          >
            <i class="fa fa-power-off" aria-hidden="true"></i>
          </button>

          <div class="text-center mt-3">
            <app-virtual-weight
              *ngIf="feeder.virtual_weight"
              [percent]="feeder.virtual_weight.percentage ? feeder.virtual_weight.percentage : 0 "
              [width]="100"
              [height]="100"
              [feeder]="feeder"
              (onClick)="onClickVirtualWeight($event)"
            ></app-virtual-weight>
            <h3>
              {{ feeder.virtual_weight.target_kgs ? feeder.virtual_weight.target_kgs : 0}} kg.
            </h3>
            {{ "comparation-weight-sensor.digital" | translate }}
          </div>
          <div class="text-center mt-3">
            <app-virtual-weight
              *ngIf="feeder.weight_sensor && feeder"
              [percent]=" feeder.weight_sensor.percentage ? feeder.weight_sensor.percentage: 0"
              [width]="100"
              [height]="100"
              [feeder]="feeder"
              (onClick)="onClickVirtualWeight($event)"
            ></app-virtual-weight>
            <h3>
              {{ feeder.weight_sensor.total_food ? feeder.weight_sensor.total_food / 100 : 0}} kg.
            </h3>
            {{ "comparation-weight-sensor.scale" | translate }}
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="section == 'configuration'">
      <div class="col-12">
        <div class="p-3 mt-2 mb-4">
          <div>
            <h3>{{ "comparation-weight-sensor.scale-config" | translate }}</h3>
          </div>
          <hr />

          <p>{{ "comparation-weight-sensor.calibrate-hint" | translate }}</p>
          <div class="d-flex">
            <input
              type="number"
              class="form-control w-50 mr-2"
              [(ngModel)]="calibrate"
              name="calibrate"
            />
            <div class="d-flex">
              <button
                class="btn btn-info mr-3"
                (click)="setCalibrate()"
                style="padding: 4px 20px 4px 20px"
              >
                {{ "comparation-weight-sensor.calibrate" | translate }}
              </button>
            </div>
          </div>
          <div class="d-flex align-items-center mt-3">
            <p class="m-0">{{ "comparation-weight-sensor.tare-hint" | translate }}</p>
            <button
              class="btn btn-secondary ml-2"
              (click)="setTarar()"
              style="padding: 4px 20px 4px 20px"
            >
              {{ "comparation-weight-sensor.tare" | translate }}
            </button>
          </div>
          <hr />
          <div class="d-flex justify-content-between align-items-center">
            <p>
              {{ "comparation-weight-sensor.click-to-activate" | translate }}
              <a class="text-warning c-pointer" (click)="setFrequencyMinute()">{{ "comparation-weight-sensor.every-minute" | translate }}</a>
            </p>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="col-12">
      <div class="d-flex border-none">
        <button
          class="btn w-100 rounded-0"
          (click)="changeSection('')"
          [class]="section === '' ? 'btn-success' : 'btn-primary'"
        >
          {{ "clients.pond.header.data" | translate }}
        </button>
        <button
          class="btn w-100 rounded-0"
          (click)="changeSection('configuration')"
          [class]="section === 'configuration' ? 'btn-success' : 'btn-primary'"
        >
          {{ "offsidebar.config.settings" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
